import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { getPageStatus, PageLayout } from 'components/PageLayout';
import { useInboxMessages } from 'features/inboxMessages/hooks/useInboxMessages';
import { MessagesContent } from './MessagesContent';

const Content = (): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('messagesInbox.title')}</title>
      </Helmet>
      <MessagesContent />
    </>
  );
};

export const MessagesInbox = (): JSX.Element => {
  const { t } = useTranslation();
  const { loading, error } = useInboxMessages({ refetchOnMount: true });

  const status = getPageStatus({ isLoading: loading, isError: error });

  return (
    <PageLayout
      data-cname="InboxMessagesPage"
      status={status}
      headerBarProps={{
        title: t('messagesInbox.title'),
        action: status === 'ready' ? '/' : 'back',
      }}
    >
      <Content />
    </PageLayout>
  );
};
